import { SettingsIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { useDeskId } from '@/hooks/useDeskId';
import { selectAccountSlug } from '@/redux/session/selectors';

/** Empty state prompting channel setup when no messaging integrations exist. `onClose` closes the host modal on link click. */
export const NoIntegrationsEmptyState = ({ onClose }: { onClose?: () => void }) => {
  const { t } = useTranslation();
  const slug = useSelector(selectAccountSlug);
  const deskId = useDeskId();

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-stroke bg-bg-muted p-8 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-background">
        <SettingsIcon className="h-6 w-6 text-foreground-muted" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium text-foreground">
          {t('conversation.new_message.no_integrations_title')}
        </p>
        <p className="text-sm text-foreground-muted">
          {t('conversation.new_message.no_integrations_description')}
        </p>
      </div>
      <Link
        to={`/${slug}/environments/${deskId}/integrations`}
        onClick={onClose}
        className="text-sm font-medium text-primary"
      >
        {t('conversation.new_message.setup_integration')}
      </Link>
    </div>
  );
};
